import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { InputComponent } from '../../../shared/input/input.component';
import { ButtonModule } from 'primeng/button';
import { Region } from '../../../model/region/region.model';

@Component({
  selector: 'app-region-form-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    InputComponent,
    ButtonModule
  ],
  templateUrl: './region-form-modal.component.html',
  styleUrls: ['./region-form-modal.component.scss']
})
export class RegionFormModalComponent {
  @Output() save: EventEmitter<Region> = new EventEmitter<Region>();

  visible: boolean = false;
  isNewRegion: boolean = true;

  regionForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.regionForm = this.fb.group({
      id: [null],
      name: [null, Validators.required]
    });
  }

  show(region?: Region) {
    if (region) {
      this.isNewRegion = false;
      this.regionForm.setValue({
        id: region.id || null,
        name: region.name || ''
      });
    } else {
      this.isNewRegion = true;
      this.regionForm.reset({ id: null, name: '' });
    }
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  onSubmit() {
    this.regionForm.markAllAsTouched();

    if (this.regionForm.valid) {
      this.save.emit(this.regionForm.value);
      this.hide();
    }
  }

  onCancel() {
    this.hide();
  }
  
  getDialogHeader(): string {
    return this.isNewRegion
      ? $localize`:@@region.createTitle:Create Region`
      : $localize`:@@region.editTitle:Edit Region`;
  }
}
